import { render, staticRenderFns } from "./ComplexEditor.vue?vue&type=template&id=414ccbbd&"
import script from "./ComplexEditor.vue?vue&type=script&lang=js&"
export * from "./ComplexEditor.vue?vue&type=script&lang=js&"
import style0 from "./ComplexEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('414ccbbd')) {
      api.createRecord('414ccbbd', component.options)
    } else {
      api.reload('414ccbbd', component.options)
    }
    module.hot.accept("./ComplexEditor.vue?vue&type=template&id=414ccbbd&", function () {
      api.rerender('414ccbbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ComplexEditor.vue"
export default component.exports